import React, { useState, useEffect } from "react";
import axios from "axios";
import "../Assests/Scss/PerformanceTrends.scss";
import Multilinechart from "./Multilinechart";
import CopyRight from "../Reusablecomponents/Copyright";
import InternetChecking from "../Reusablecomponents/Network";
import { useSelector } from "react-redux";
import { FaAnglesLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { Year } from "../Reusablecomponents/RegularFunctions";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";
import DataTable from "../Reusablecomponents/DataTable/DataTable";
import { DownloadExcel } from "../../ReusableComponents/CommonFunctions";
import { ExportXlButton } from "../../ReusableComponents/CommonComponents";

const PerformanceTrends = () => {
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [TrendsData, SeTrendsData] = useState([]);
  const [SelectedTests, SetSelectedTests] = useState([]);

  const USYear = useSelector((state) => state.SelecYearData.SYear);

  const GeTrendsData = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/StudentResults/GetStudentsPerformanceTrends?UserId=${items.userId}&Year=${USYear?.value}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SeTrendsData(res.data);
        SetSelectedTests(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GeTrendsData();
  }, [USYear]);

  const TrendsColumns = [
    { name: "Assessment type", sortable: true, selector: "assessmentTypeNo" },
    { name: "Assessment date", selector: "paperName", sortable: true },
    {
      name: "% in English",
      selector: "englishPercenatage",
      sortable: true,
      cell: (row) => <> {row.englishPercenatage}% </>,
    },
    {
      name: "% in Mathematics",
      selector: "mathePercenatge",
      sortable: true,
      cell: (row) => <> {row.mathePercenatge}% </>,
    },
    {
      name: "% in Science",
      selector: "sciencePercentage",
      sortable: true,
      cell: (row) => <> {row.sciencePercentage}% </>,
    },
    ...(items?.grade < 11 && TrendsData[0]?.optionalLanguage)?[ {
      name: `% in ${TrendsData[0]?.optionalLanguage}`,
      selector: "optionalLanguagePercentage",
      sortable: true,
      cell: (row) => <> {row.optionalLanguagePercentage}% </>,
    }]:[],
    {
      name: "Total %",
      selector: "overallPercentage",
      sortable: true,
      cell: (row) => <> {row.overallPercentage}% </>,
    },
  ];
  const DownloadTrends = () => {
    const XL = SelectedTests?.map((item, index) => {
      return {
        SNo: index + 1,
        "Assessment type": item.assessmentTypeNo,
        "Assessment date": item.paperName,
        "% in English": `${item.englishPercenatage}%`,
        "% in Mathematics": `${item.mathePercenatge}%`,
        "% in Science": `${item.sciencePercentage}%`,
        ...(items?.grade <11 && {
    [`% in ${TrendsData[0]?.optionalLanguage}`]: `${item.optionalLanguagePercentage ?? 0}%`}),
        "Total %": `${item.overallPercentage}%`,
      };
    });
    DownloadExcel(
      XL,
      "Performance Trends",
      false,
      "Performance Trends",
      "Performance Trends",
      true
    );
  };
  return (
    <>
      <div className="Instructions-pages PMain-Div">
        <InternetChecking />
        <p>
          {" "}
          Student Performance Trends -
          {process.env.REACT_APP_NCLEXAMDISPLAYNAME1} and{" "}
          {process.env.REACT_APP_NCLEXAMDISPLAYNAME2} - {USYear?.display}{" "}
        </p>

        <div className="dflex Trends-Details gap-4">
          <div style={{ width: "45%" }}>
            <Multilinechart TrendsData={SelectedTests} />{" "}
          </div>
          <div className="Card">
            <div className="dflex JSBetween px-4 mb-2 mx-2">
              {" "}
              <div></div>{" "}
              {TrendsData.length > 0 && (
                <ExportXlButton
                  Name="Export to Excel"
                  Click={() => DownloadTrends()}
                />
              )}
            </div>

            <DataTable
              data={TrendsData}
              showCheckboxes={true}
              GetSelectData={SetSelectedTests}
              PostSelectData={SelectedTests}
              columns={TrendsColumns}
              Search={true}
              className="STudenTable"
            />
          </div>
        </div>
        <CopyRight />
      </div>
    </>
  );
};
export default PerformanceTrends;
